export default __webpack_public_path__ + "static/Obsidian-89e325e5cd1c6c1bf922f46668e9647b.png";